import React from 'react';

import { useTheme, makeStyles } from '@material-ui/core/styles';

import LayoutShell from '@hydra/common/shell/LayoutShell';
import { Header, Footer, RailNavigation } from '@hydra/common/components';
import { useUserContext, useReviewContext, useErrorContext } from '@hydra/common/context';
import HeaderFooterShell from '@hydra/common/shell/HeaderFooterShell';

import { useSideNav } from '@hydra/common/customHooks';

import { getIsDudaUser } from '@hydra/utils/userUtil';
import isInIframe from '@hydra/utils/isInIframe';

import { Shell } from '@hydra/types/shell';

interface ReviewshellProps extends Shell {
  section: string
  isGenerating: boolean
}

const useStyles = makeStyles({ root: { display: 'flex' } });

export default function ReviewShell (props: ReviewshellProps) {
  const theme = useTheme();
  const classes = useStyles();
  const {
    children,
    section,
    className,
    isGenerating,
    hideFooter = false,
    bgColor = theme.palette.background.default
  } = props;
  const { sideNavOpen, handleSidenav } = useSideNav();
  const { user } = useUserContext();
  const { error = false } = useErrorContext();
  const { isReview } = useReviewContext();
  const isDudaUser = getIsDudaUser(user);
  const inIframe = isInIframe() === null ? true : isInIframe();

  const isLoggedIn = !!(user && user.id);
  const isNotFound = error && (error.message === 'not_found');
  const showSideNav = isLoggedIn && !isNotFound && !isGenerating && isReview;
  const LayoutShellProps = showSideNav ? { sideNavType: 'mini', sideNav: showSideNav } : {};

  return showSideNav
    ? (
      <>
        {
          !(isDudaUser && inIframe)
            ? (
              <>
                <Header sideNavToggle={handleSidenav} />
                <RailNavigation
                  active={section}
                  onClose={handleSidenav}
                  open={sideNavOpen}
                />
              </>
              )
            : null
        }
        <LayoutShell
          {...LayoutShellProps}
          bgColor={bgColor}
          className={className}
        >
          {children}
        </LayoutShell>
        {
          !hideFooter
            ? <Footer bgColor={bgColor} />
            : null
        }
      </>
      )
    : (
      <>
        <HeaderFooterShell
          hideHeader={isDudaUser && inIframe}
          bgColor={bgColor}
          className={classes.root}
          hideFooter={isGenerating}
        >
          {children}
        </HeaderFooterShell>
      </>
      );
}
